/* 🤖 this file was generated by svg-to-ts */
export const matIconMeetingRoom: {
  name: 'meeting-room';
  data: string;
} = {
  name: 'meeting-room',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M19 19V4h-4V3H5v16H3v2h12V6h2v15h4v-2h-2zm-6 0H7V5h6v14zm-3-8h2v2h-2z"/></svg>`
};
